import { axiosJWTInstance } from "../../utils/axiosJWTInstance";
import { Dispatch } from "redux";
import {
    GET_OPERATION_TYPES_ATTEMPT,
    GET_OPERATION_TYPES_SUCCESS,
    GET_OPERATION_TYPES_FAILURE,
} from "../constants";

// getOperationTypes actions
const getOperationTypesAttempt = () => ({
    type: GET_OPERATION_TYPES_ATTEMPT,
});

const getOperationTypesSuccess = (payload: any) => ({
    type: GET_OPERATION_TYPES_SUCCESS,
    payload,
});

const getOperationTypesFailure = (error: string) => ({
    type: GET_OPERATION_TYPES_FAILURE,
    payload: {
        error,
    },
});

export const getOperationTypesRequest = (data: any, paramsToAdd?:any) => (dispatch: Dispatch) => {
    dispatch(getOperationTypesAttempt());

    const params2 = {
        entity: "operation_types",
        ...paramsToAdd
    }

    const searchParams = new URLSearchParams(params2);
    const webUrl = `/Orders?${searchParams.toString()}`;

    return axiosJWTInstance
        .post(webUrl, data, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "content-type": "application/json",
            }
        })
        .then((res) => {
            res.data.data = res.data.data.map((x: any) => {
                return {...x, joined: `${x.axumOperationTypeCode} - ${x.operationType}`}
            });
            return res.data;
        })
        .then((payload) => {
            dispatch(getOperationTypesSuccess(payload));
        })
        .catch((error) => {
            dispatch(getOperationTypesFailure(error.message));
        });
};